var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash/get';
import envConfig from 'conversional-environment';
var env = process.env.REACT_APP_JOURNEY_ENV || 'development';
export function initializeWidgetErrorTracker(journey) {
    var errorTracker = get(journey, 'tracking.errorTracker', 'sentry');
    switch (errorTracker) {
        case 'sentry': {
            var sentryWidgetDSN_1 = get(envConfig, 'sentry.widget');
            if (sentryWidgetDSN_1) {
                import('@sentry/react').then(function (Sentry) {
                    var integrations = [];
                    var sentryOptions = {};
                    var sessionReplayEnabled = get(journey, 'tracking.sessionReplay', false);
                    if (sessionReplayEnabled) {
                        integrations.push(new Sentry.Replay({
                            maskAllText: false,
                        }));
                        /**
                         * We'll set the integration but we do not start recording by Sentry manually.
                         * The reason is, we are not running the Sentry SDK in the main thread, but in the iframe.
                         * The iframe will be open and the application is going to be used by some user interaction.
                         *
                         * If set to true, Sentry will start recording the session immediately, which is not what we want since it will record all user
                         * sessions on the host page regardless of whether the user is opening the widget or not.
                         *
                         * We have `triggerReplay` function below for the widget to start recording the session when the widget is opened and stop it when closed.
                         * */
                        sentryOptions.replaysSessionSampleRate = 0;
                        sentryOptions.replaysOnErrorSampleRate = 0;
                    }
                    function hasExceptions(event) {
                        return event.exception && event.exception.values && event.exception.values.length > 0;
                    }
                    function isInvalidZipCodeError(exception) {
                        var _a, _b;
                        /* Todo: this message is going to have info + translation on backend and
                the main message now is : The zip code is invalid, please provide a valid zip code. */
                        return (exception.type === 'Error' &&
                            ((_a = exception.value) === null || _a === void 0 ? void 0 : _a.includes('400')) &&
                            ((_b = exception.value) === null || _b === void 0 ? void 0 : _b.includes('The zip code is invalid')));
                    }
                    function shouldIgnoreSentryEvent(event) {
                        var _a, _b;
                        if (event.level === 'info')
                            return true;
                        if (!hasExceptions(event))
                            return false;
                        var exception = (_b = (_a = event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0];
                        if (isInvalidZipCodeError(exception))
                            return true;
                        return false;
                    }
                    Sentry.init(__assign(__assign({}, sentryOptions), { dsn: sentryWidgetDSN_1, beforeSend: function (event) {
                            if (shouldIgnoreSentryEvent(event)) {
                                return null;
                            }
                            return event;
                        }, initialScope: {
                            tags: {
                                journeyId: get(journey, 'id'),
                                origin: get(window, 'conversional.origin'),
                                iframe: get(journey, 'iframe.viewConfig.template'),
                            },
                        }, 
                        // Reason: https://bitbucket.org/ConversionalDev/conversional-frontend/pull-requests/1157
                        ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'], environment: env, 
                        // debug: env === "development",
                        release: get(window, 'conversionalLauncherHostObject.release'), integrations: integrations, tracesSampleRate: 0 }));
                });
            }
        }
    }
}
var _recording = false;
export function triggerSessionReplay(play) {
    import('@sentry/react').then(function (Sentry) {
        var client = Sentry.getCurrentHub().getClient();
        if (!client)
            return;
        var replay = client === null || client === void 0 ? void 0 : client.getIntegration(Sentry.Replay);
        // Returns null if replay module is not integrated
        if (!replay)
            return;
        if (play && !_recording) {
            _recording = true;
            replay.start();
            return;
        }
        if (!play && _recording) {
            _recording = false;
            replay.flush();
            replay.stop();
            return;
        }
    });
}
